import Vue from 'vue'
import zhData from '@/locales/translations.json';
import enData from '@/locales/translations_en.json';
import twData from '@/locales/translations_tw.json';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh-CN',
  messages: {
    'zh-CN': zhData,
    'en-US': enData,
    'zh-TW': twData
  },
  nsSeparator: false
});
